/**
 * Canonical Albanian administrative tree: 12 qarqe (counties) → 61 bashki (municipalities).
 *
 * Used by the checkout address form to drive the State → City cascade.
 *
 * Source: Republic of Albania, Law no. 115/2014 on territorial reform.
 * Spelling is the local Albanian form (with diacritics).
 */

export const AL_LOCATIONS = {
    tirane: {
        id: "tirane",
        label: "Tiranë",
        aliases: ["tirana", "tirane", "tirana county"],
        bashki: [
            { id: "tirane", label: "Tiranë", aliases: ["tirana", "tirana city", "bashkia tirana", "bashkia tirane"] },
            { id: "kamez", label: "Kamëz", aliases: ["kamza"] },
            { id: "vore", label: "Vorë", aliases: ["vora"] },
            { id: "kavaje", label: "Kavajë", aliases: ["kavaja"] },
            { id: "rrogozhine", label: "Rrogozhinë", aliases: ["rrogozhina"] },
        ],
    },
    durres: {
        id: "durres",
        label: "Durrës",
        aliases: ["durres", "durazzo"],
        bashki: [
            { id: "durres", label: "Durrës", aliases: ["durazzo"] },
            { id: "shijak", label: "Shijak", aliases: [] },
            { id: "kruje", label: "Krujë", aliases: ["kruja"] },
        ],
    },
    vlore: {
        id: "vlore",
        label: "Vlorë",
        aliases: ["vlora", "valona"],
        bashki: [
            { id: "vlore", label: "Vlorë", aliases: ["vlora"] },
            { id: "sarande", label: "Sarandë", aliases: ["saranda"] },
            { id: "himare", label: "Himarë", aliases: ["himara"] },
            { id: "selenice", label: "Selenicë", aliases: [] },
            { id: "konispol", label: "Konispol", aliases: [] },
            { id: "finiq", label: "Finiq", aliases: [] },
            { id: "delvine", label: "Delvinë", aliases: ["delvina"] },
        ],
    },
    fier: {
        id: "fier",
        label: "Fier",
        aliases: ["fieri"],
        bashki: [
            { id: "fier", label: "Fier", aliases: ["fieri"] },
            { id: "lushnje", label: "Lushnjë", aliases: ["lushnja"] },
            { id: "patos", label: "Patos", aliases: [] },
            { id: "roskovec", label: "Roskovec", aliases: [] },
            { id: "mallakaster", label: "Mallakastër", aliases: [] },
            { id: "divjake", label: "Divjakë", aliases: ["divjaka"] },
        ],
    },
    elbasan: {
        id: "elbasan",
        label: "Elbasan",
        aliases: ["elbasani"],
        bashki: [
            { id: "elbasan", label: "Elbasan", aliases: ["elbasani"] },
            { id: "cerrik", label: "Cërrik", aliases: ["cerriku"] },
            { id: "belsh", label: "Belsh", aliases: [] },
            { id: "gramsh", label: "Gramsh", aliases: [] },
            { id: "librazhd", label: "Librazhd", aliases: [] },
            { id: "peqin", label: "Peqin", aliases: [] },
            { id: "prrenjas", label: "Prrenjas", aliases: [] },
        ],
    },
    berat: {
        id: "berat",
        label: "Berat",
        aliases: ["berati"],
        bashki: [
            { id: "berat", label: "Berat", aliases: ["berati"] },
            { id: "kucove", label: "Kuçovë", aliases: ["kucova"] },
            { id: "skrapar", label: "Skrapar", aliases: [] },
            { id: "polican", label: "Poliçan", aliases: [] },
            { id: "ura_vajgurore", label: "Ura Vajgurore", aliases: [] },
        ],
    },
    lezhe: {
        id: "lezhe",
        label: "Lezhë",
        aliases: ["lezha", "lezhna"],
        bashki: [
            { id: "lezhe", label: "Lezhë", aliases: ["lezha"] },
            { id: "kurbin", label: "Kurbin", aliases: ["lac"] },
            { id: "mirdite", label: "Mirditë", aliases: ["mirdita"] },
        ],
    },
    shkoder: {
        id: "shkoder",
        label: "Shkodër",
        aliases: ["shkodra", "scutari", "shkodër"],
        bashki: [
            { id: "shkoder", label: "Shkodër", aliases: ["shkodra"] },
            { id: "malesi_e_madhe", label: "Malësi e Madhe", aliases: ["koplik"] },
            { id: "puke", label: "Pukë", aliases: ["puka"] },
            { id: "vau_i_dejes", label: "Vau i Dejës", aliases: [] },
            { id: "fushe_arrez", label: "Fushë-Arrëz", aliases: ["fush-arrez", "fushearrez"] },
        ],
    },
    korce: {
        id: "korce",
        label: "Korçë",
        aliases: ["korca", "korce", "korçë"],
        bashki: [
            { id: "korce", label: "Korçë", aliases: ["korca"] },
            { id: "bilisht", label: "Bilisht", aliases: [] },
            { id: "devoll", label: "Devoll", aliases: [] },
            { id: "pogradec", label: "Pogradec", aliases: [] },
            { id: "maliq", label: "Maliq", aliases: [] },
            { id: "pustec", label: "Pustec", aliases: [] },
            { id: "kolonje", label: "Kolonjë", aliases: ["kolonja", "erseke"] },
        ],
    },
    kukes: {
        id: "kukes",
        label: "Kukës",
        aliases: ["kukesi"],
        bashki: [
            { id: "kukes", label: "Kukës", aliases: ["kukesi"] },
            { id: "has", label: "Has", aliases: ["krume"] },
            { id: "tropoje", label: "Tropojë", aliases: ["b. curri", "bajram curri"] },
        ],
    },
    diber: {
        id: "diber",
        label: "Dibër",
        aliases: ["dibra", "diber"],
        bashki: [
            { id: "peshkopi", label: "Peshkopi", aliases: [] },
            { id: "bulqize", label: "Bulqizë", aliases: ["bulqiza"] },
            { id: "klos", label: "Klos", aliases: [] },
            { id: "mat", label: "Mat", aliases: ["burrel"] },
        ],
    },
    gjirokaster: {
        id: "gjirokaster",
        label: "Gjirokastër",
        aliases: ["gjirokastra", "argyrokastro"],
        bashki: [
            { id: "gjirokaster", label: "Gjirokastër", aliases: ["gjirokastra"] },
            { id: "permet", label: "Përmet", aliases: ["permeti"] },
            { id: "tepelene", label: "Tepelenë", aliases: ["tepelena"] },
            { id: "memaliaj", label: "Memaliaj", aliases: [] },
            { id: "libohove", label: "Libohovë", aliases: ["libohova"] },
            { id: "dropull", label: "Dropull", aliases: [] },
            { id: "kelcyre", label: "Këlcyrë", aliases: ["kelcyra"] },
        ],
    },
};

// Ordered list of qarqe (for the dropdown rendering order)
export const AL_QARQE_ORDERED = [
    "tirane", "durres", "vlore", "fier", "elbasan", "berat",
    "lezhe", "shkoder", "korce", "kukes", "diber", "gjirokaster",
];

/**
 * Reverse lookup: given a label (e.g. "Tirana" or "Tiranë" coming from Google's reverse-geocode),
 * return the canonical qark id and label. Returns null if not recognised.
 */
const _normalize = (s) =>
    (s || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");

export const findQarkByLabel = (raw) => {
    const n = _normalize(raw);
    if (!n) return null;
    for (const id of AL_QARQE_ORDERED) {
        const q = AL_LOCATIONS[id];
        if (_normalize(q.label) === n || _normalize(q.id) === n) return q;
        // Aliases (e.g. "tirana" → "tirane")
        if (q.aliases && q.aliases.some((a) => _normalize(a) === n)) return q;
    }
    return null;
};

export const findBashkiByLabel = (qarkId, raw) => {
    const q = AL_LOCATIONS[qarkId];
    if (!q) return null;
    const n = _normalize(raw);
    if (!n) return null;
    for (const b of q.bashki) {
        if (_normalize(b.label) === n || _normalize(b.id) === n) return b;
        if (b.aliases && b.aliases.some((a) => _normalize(a) === n)) return b;
    }
    return null;
};

// Search across all qarqe for a bashki name. Useful when the map gives us only a city
// name without a clear state — we infer the state from the city.
export const findBashkiAnywhere = (raw) => {
    const n = _normalize(raw);
    if (!n) return null;
    for (const id of AL_QARQE_ORDERED) {
        const q = AL_LOCATIONS[id];
        for (const b of q.bashki) {
            if (
                _normalize(b.label) === n
                || _normalize(b.id) === n
                || (b.aliases && b.aliases.some((a) => _normalize(a) === n))
            ) {
                return { qark: q, bashki: b };
            }
        }
    }
    return null;
};

// Reasonable subset of countries for the country dropdown. Only Albania is enabled — the rest
// render greyed out to advertise future expansion (matches the login-country UX from iter 16).
export const COUNTRIES = [
    { iso: "AL", name: "Albania", flag: "🇦🇱", enabled: true },
    { iso: "IT", name: "Italy", flag: "🇮🇹", enabled: false },
    { iso: "GR", name: "Greece", flag: "🇬🇷", enabled: false },
    { iso: "ME", name: "Montenegro", flag: "🇲🇪", enabled: false },
    { iso: "MK", name: "North Macedonia", flag: "🇲🇰", enabled: false },
    { iso: "XK", name: "Kosovo", flag: "🇽🇰", enabled: false },
    { iso: "IN", name: "India", flag: "🇮🇳", enabled: false },
    { iso: "DE", name: "Germany", flag: "🇩🇪", enabled: false },
    { iso: "GB", name: "United Kingdom", flag: "🇬🇧", enabled: false },
    { iso: "US", name: "United States", flag: "🇺🇸", enabled: false },
];
